import React from 'react'

const Subscribe = () => {
    return (
        <>
            <section id="subscribe-five" className="subscribe-five-main-block">
                <div className="container">
                    <div className="subscribe-five-block">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3 col-md-10 offset-md-1">
                                <div className="subscribe-five-mail-icon">
                                    <i className="flaticon-letter" />
                                </div>
                                <h3 className="subscribe-five-title">
                                    Subscribe your <br /> Email for Newsletter
                                </h3>
                                <form className="subscribe-five-form">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="floatingInput"
                                            placeholder="name@example.com"
                                        />
                                        <label htmlFor="floatingInput">Email Address</label>
                                    </div>
                                    <button type="button" className="btn btn-primary-five">
                                        <i className="flaticon-message" />
                                        Subscribe
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Subscribe
